<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>รายงานอะไหล่ เข้า/ออก</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'
                 @onUserBranchNameChange='setCurrentBranchName'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>

            <template>
                <v-container>
                    <v-card outlined>
                        <v-card-subtitle class="pb-0">
                        <v-row>
                            <v-col><DatePicker label="ตั้งแต่ วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                            <v-col><DatePicker label="ถึง วันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                     <v-btn  class="ma-2" color="primary" small @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
                                </v-row>
                            </v-col>
                            
                        </v-row>             
                        </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>

         <template  width="1000px">
            <v-data-table 
                :headers="headers"
                :items="items"
                class="pt-5"
                fixed-header
                height="350"
                >
            </v-data-table>
         </template>
        </v-card>       
    </v-container>
</template>

<script>

 import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
 import DatePicker from '@/components/Shared/DatePicker'
 import {listTrnPart,exportTrnPart} from '@/api/reports/report-api.js'
import numeral from 'numeral'
export default {
    name: 'trnPartReport',
    components: {
        UserBranchDropdown,
        DatePicker
    },
   props:["pageCode"],
    data: () => ({
         headers: [
                        {text: "รหัสอะไหล่", value: "partsCode"},
                        {text: "รายการอะไหล่", value: "partsName"},
                        {text: "ราคา/หน่วย", value: "unitPriceDisplay"},
                        {text: "เลขที่ใบสั่งซ่อม", value: "jobNo"},
                        {text: "ทะเบียน", value: "licenseNo"},
                        {text: "จำนวน Stock IN", value: "sumStockIn"},
                        {text: "ยอดรวม Stock IN", value: "totalStockInDisplay"},
                        {text: "จำนวน Stock OUT", value: "sumStockOut"},
                        {text: "ยอดรวม Stock OUT", value: "totalStockOutDisplay"},
                        {text: "คงเหลือ", value: "totalSum"},
                      
                    ],
        items: [],
    }),
    methods: {
            setDateFrom(val) {
                  this.dateFrom = val;
            },
            setDateTo(val) {
                  this.dateTo = val;
            },
            setCurrentBranch(branchCode) {
                this.branchCode = branchCode;
            },
            setCurrentBranchName(branchName) {
                this.branchName = branchName;
            },
            search(){
              this.$loading(true);
                listTrnPart(this.branchCode,this.dateFrom,this.dateTo).then(response => {
                this.items = response;
                if (this.items) {
                this.items.forEach((e) => {
                    e.unitPriceDisplay = numeral(e.unitPrice).format('0,0.00');
                    e.totalStockInDisplay = numeral(e.totalStockIn).format('0,0.00');
                    e.totalStockOutDisplay = numeral(e.totalStockOut).format('0,0.00');  
                    
                    });
                 }
                this.$loading(false);
                }).catch(()=> {
                    this.$loading(false);
                });
            },
            createReport(){
                this.$loading(true);
                exportTrnPart(this.branchCode,this.branchName,this.dateFrom,this.dateTo);
                this.$loading(false);
            },
    }
}
</script>